/* eslint-disable */
import Util from '../../../js/helpers/util';

jQuery(document).ready(function() {
	const backToTopBtn = document.getElementsByClassName('back-to-top-btn')[0];
	const offset = 300;
	const offsetOpacity = 1500;
	const scrollDuration = 700;
	let scrolling = false;

	const checkBackToTop = () => {
		const windowTop = window.scrollY || document.documentElement.scrollTop;
		( windowTop > offset ) ? Util.addClass(backToTopBtn, 'back-to-top-btn--is-visible') : Util.removeClass(backToTopBtn, 'back-to-top-btn--is-visible back-to-top-btn--fade-out');
		( windowTop > offsetOpacity ) && Util.addClass(backToTopBtn, 'back-to-top-btn--fade-out');
		scrolling = false;
	}

	if( backToTopBtn ) {
		// Update back to top visibility on scrolling
		window.addEventListener('scroll', (e) => {
			if( !scrolling ) {
				scrolling = true;
				(!window.requestAnimationFrame) ? setTimeout(checkBackToTop, 250) : window.requestAnimationFrame(checkBackToTop);
			}
		});

		// Smooth scroll to top with backwards compatibility
		backToTopBtn.addEventListener('click', (e) => {
			e.preventDefault();
			(!window.requestAnimationFrame) ? window.scrollTo(0, 0) : Util.scrollTo(0, scrollDuration);
		});
	}
});
